import React, { memo } from "react";
import { Switch as AntSwitch } from "antd";
import type { SwitchProps as AntSwitchProps } from "antd";
import { cn } from "src/util/cn";
import "./CustomSwitch.css";

export interface CustomSwitchProps extends AntSwitchProps {
  className?: string;
}

const CustomSwitch: React.FC<CustomSwitchProps> = ({ className, ...props }) => (
  <AntSwitch className={cn("custom-switch", className)} {...props} />
);

export default memo(CustomSwitch);
